import { Prefab } from '@gift/basic-scene-core/Prefab';
import { EntityState } from '@reduxjs/toolkit';
import { Json } from '@gift/types/Json';
import { Translate } from '@gift/types/generic/Translate';
import { createPaintables } from '@gift/common/helpers/createPaintables';
import { mergeInputsInto } from './mergeInputsIntoPrefab';

export function createPrefabPreviewPaintables(
    prefab: Prefab,
    userInputs: EntityState<Json.Input<any>>,
    variant: Json.Variant<any>,
    t: Translate
) {
    const variables = Object.values(prefab.variables.entities) as Json.Variable<any>[];
    const inputs = mergeInputsInto(prefab, userInputs, t, { direction: 'inputIntoPrefab' });
    return createPaintables(variables, inputs.entities, variant, 'icon');
}